// extracted by mini-css-extract-plugin
module.exports = {"root":"Previewer_root__BnfbW","img":"Previewer_img__rmjY5","video":"Previewer_video__jcK5H","pdf":"Previewer_pdf__ZUHwu"};